import { recruiterJobConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import { showSuccessMessage } from "../../../_uiComponents/ShowMessageSnack";

const user = JSON.parse(localStorage.getItem("jigsawUser"));

//get all jobs
export const get_all_jobs_recruiter_action = (page) => async (dispatch) => {
  dispatch({
    type: recruiterJobConstants.GET_ALL_JOBS_RECRUITER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      `${config.common.allJobs}?page=${page ? page : 1}`
    );
    if (response.status) {
      dispatch({
        type: recruiterJobConstants.GET_ALL_JOBS_RECRUITER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: recruiterJobConstants.GET_ALL_JOBS_RECRUITER_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//get all jobs
export const assign_candidate_to_job_recruiter_action =
  (data) => async (dispatch) => {
    dispatch({
      type: recruiterJobConstants.ASSIGN_CANDIDATE_TO_JOB_RECRUITER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.recruiter.assignCandidateToJob,
        data
      );
      if (response.status) {
        dispatch({
          type: recruiterJobConstants.ASSIGN_CANDIDATE_TO_JOB_RECRUITER_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Candidate successfully assigned to job.");

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: recruiterJobConstants.ASSIGN_CANDIDATE_TO_JOB_RECRUITER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };
